import { useMemo } from 'react'

import { statusDisplaysFrom } from './useStatusDisplay'
import resolveStatusColors, { ADRESS_STATUS_DEFAULT_COLORS } from '../helpers/statusConfig/resolveStatusColors'
import buildAdressStatusById from '../helpers/calendar/adressStatusById'

/**
 * Per huishouden het woord en de kleur van zijn status, voor het bolletje in
 * het agendablok van een huisbezoek. Eén hook voor de drie schermen die het
 * tekenen (Agenda, dashboardkaart, 'Lijst en agenda'); geef de uitkomst als
 * prop `adressStatusById` aan `CalendarView`.
 *
 * Leest zelf niets: de huishoudens en de instelling komen van de aanroeper,
 * want die heeft ze al (en poort de lezing op de module Huishoudens).
 * AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook
 * AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
 *
 * @param {Array<object>|undefined|''} adresses - De huishoudens; niet-array = nog onderweg
 * @param {object} [adressStatusConfig] - `useSettings().adressStatusConfig`
 * @returns {Record<string, import('../helpers/calendar/adressStatusById').AdressStatusBadge>}
 */
const useAdressStatusById = (adresses, adressStatusConfig) => useMemo(
    () => buildAdressStatusById(
        adresses,
        statusDisplaysFrom({ adressStatusConfig }).adress,
        resolveStatusColors(ADRESS_STATUS_DEFAULT_COLORS, adressStatusConfig),
    ),
    [adresses, adressStatusConfig],
)

export default useAdressStatusById
